export default {
  container: {
    textAlign: 'center',
  },
};
